import { Component, OnInit } from '@angular/core';
import { FaqService } from './services/faq.service';
import { SortedArticles, Article } from './services/faq.interface';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit {
  isVisible = false;
  activeBlockNumber = 0;
  articles: SortedArticles | null = null;
  categories: string[] | null = null;
  loading = false;

  constructor(private faqService: FaqService) {}

  ngOnInit(): void {
    this.loading = true;
    this.faqService.getArticles().subscribe(
      (response: any) => {
        this.articles = this.mapArticlesToSortedArticles(response.body);
        this.categories = this.articles ? Object.keys(this.articles) : null;
      },
      (error: any) => {},
      () => {
        this.loading = false;
      }
    );
  }

  mapArticlesToSortedArticles(articles: SortedArticles): SortedArticles | null {
    const sortedArticles: SortedArticles = {};

    if (articles) {
      articles.articles.forEach((article: Article) => {
        if (!sortedArticles[article.category.name]) {
          sortedArticles[article.category.name] = [];
        }
        sortedArticles[article.category.name].push(article);
      });
    }

    return sortedArticles;
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  handleOk(): void {
    this.isVisible = false;
  }

  setActiveBlockNumber(num: number): void {
    this.activeBlockNumber = num;
  }
}
